module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0069.jpg?v=10d83e2f";